import { h, Component } from 'preact';
import pure from 'utils/pure';
import Store from 'store/store';
import 'store/bolt/cookies';
import s from 'components/bolt/cookies/cookies.sss';
import { joinClasses } from 'utils/utils';
import HTML from 'components/core/html/html.js';
import { getRelativePageUrl, navigateInternally } from 'utils/bolt/index';

export default @pure class Cookies extends Component {
	constructor(props, ...args) {
		super(props, ...args);

		this.acceptAll = this.acceptAll.bind(this);
		this.rejectAll = this.rejectAll.bind(this);
	}

	componentDidMount() {
		const data = this.props.appData?.options?.cookiesModal;
		const position = data?.position || 'fixedTop';

		if (position === 'fixedTop') {
			if (window.ResizeObserver) {
				this.resizeObserver = new ResizeObserver(entries => {
					Store.emit('SET_COOKIE_BAR_HEIGHT', entries[0].borderBoxSize[0].blockSize);
				});
				this.resizeObserver.observe(this.base);
			} else {
				Store.emit('SET_COOKIE_BAR_HEIGHT', this.base.offsetHeight);
			}
		}

	}

	componentWillUnmount() {
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
		}
	}

	acceptAll() {
		if (this.props.onAccept) {
			this.props.onAccept();
		}

		Store.emit('ACCEPT_COOKIES', this.props.categories);
	}

	rejectAll() {
		Store.emit('ACCEPT_COOKIES', this.props.categories.filter(e => e === 'STRICTLY_NECESSARY'));
	}

	openPreferences() {
		Store.emit('COOKIE_PREFERENCES_OPEN');
	}

	renderText() {
		const appData = this.props.appData;
		const cookiesModal = appData?.options?.cookiesModal;
		const fontStyles = appData?.styling?.fontVariables;
		if (cookiesModal?.legalCopy) {
			return (
				<HTML class={joinClasses(s.text, fontStyles.cookieBannerCopy)} content={cookiesModal?.legalCopy} markdown />
			);
		}

		const href = cookiesModal.link || appData?.urls?.cookieTextLink;
		let linkAttributes = { href, target: '_blank', rel: 'noopener noreferrer' };

		let [pageIdRaw, hash] = href?.split('#') || [];
		let [pageId, queryStringRaw] = pageIdRaw?.split('?') || [];
		if (appData?.pages?.[pageId]) {
			linkAttributes = {
				href: getRelativePageUrl(pageId, queryStringRaw ? `?${queryStringRaw}` : '', hash) || '#',
				onClick: () => navigateInternally(pageId, { instant: false, queryString: queryStringRaw }),
			};
		}
		const copy = appData?.copy?.baseCopy;
		return (
			<div class={joinClasses(s.text, fontStyles.cookieBannerCopy)}>
				{!!copy?.$COOKIE_TEXT_START && <HTML tag="span" content={copy.$COOKIE_TEXT_START + ' '} markdown inline />}
				<a class={fontStyles.cookiePolicyLink} {...linkAttributes}>{copy?.$COOKIE_LINK_COPY}</a>
				{!!copy?.$COOKIE_TEXT_END && <HTML tag="span" content={' ' + copy.$COOKIE_TEXT_END} markdown inline />}
			</div>
		);
	}

	renderButtons() {
		const appData = this.props.appData;
		const cookiesModal = appData?.options?.cookiesModal;
		const copy = appData?.copy?.baseCopy;
		const fontStyles = appData?.styling?.fontVariables;
		return [
			<button class={joinClasses(s.button, s.accept, fontStyles?.cookieAcceptBtn || 'smallB')} onClick={this.acceptAll} key="accept">
				{copy.$ACCEPT_COOKIES}
			</button>,
			!!cookiesModal?.declineButton && (
				<button class={joinClasses(s.button, s.decline, fontStyles?.cookieDeclineBtn || 'smallB')} onClick={this.rejectAll} key="decline">
					{copy.$REJECT_COOKIES || 'Decline'}
				</button>
			),
			<button class={joinClasses(s.button, s.settings, fontStyles?.cookieManageBtn || 'smallB')} onClick={this.openPreferences} key="settings">
				{copy.$COOKIE_SETTINGS}
			</button>,
		].filter(e => e);
	}

	render(props) {
		const data = props.appData?.options?.cookiesModal;
		const position = data?.position || 'fixedTop';

		return (
			<div
				class={joinClasses({
					s, container: true,
					hidden: props.hidden,
					lockout: data?.lockout,
					[`position-${position}`]: true,
				})}
				key="cookie"
				data-section="cookies"
			>
				{this.renderText()}
				<div class={s.buttonWrapper}>{this.renderButtons()}</div>
			</div>
		);
	}
}
